module.exports = __webpack_public_path__ + "static/img/8.e77aff0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/8.jpg
// module id = fOCh
// module chunks = 6